import * as _ from 'underscore';
import React from 'react';
import { connect } from 'react-redux';
import Button from 'material-ui/Button';

import { RepTable } from '../RepTable';
import PrescriptionDrop from '../PrescriptionDrop/PrescriptionDrop';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import Console from '../../../../lib/debug';
import * as Utils from '../../../../lib/designerUtils';
import LastPerformance from '../../../../v5/LastPerformance/components/LastPerformance';
import SegmentService, { EVENTS } from '../../../../lib/segment/SegmentService';

class ExerciseRepTable extends React.Component {
    createMarkup(v) {
        return { __html: v };
    }
    filterUpdate(newValue) {
        let newTag = newValue.length ? [newValue[newValue.length - 1]] : [];
        let dispatch = this.props.dispatch;
        let exercise = this.props.exercise;
        DesignerState.updateSchemeTags(dispatch, exercise, newTag);
    }
    formatOptions(options) {
        for (var i = 0; i < options.length; i++) {
            let option = options[i];
            if (option.title.indexOf('span') > 0) {
                option.title = option.title.replace(
                    '<span class="symbol">',
                    ''
                );
                option.title = option.title.replace('</span>', '');
            }
        }
        return options;
    }
    getOptions() {
        let exercise = this.props.exercise;
        if (!exercise.tags || (exercise.tags && exercise.tags.length === 0)) {
            return this.props.schemeRef;
        } else {
            let exerciseTagsCount = 0;
            _.map(exercise.tags, tag => {
                if (tag.type !== 4) {
                    return exerciseTagsCount++;
                }
            });
            if (exerciseTagsCount === exercise.tags.length) {
                return this.props.schemeRef;
            }
            let allSchemes = this.props.schemeRef;
            if (!allSchemes) {
                return [];
            }
            allSchemes = [...allSchemes];
            let tagResults = [];
            let selectedTagId = false;

            for (let i = 0; i < exercise.tags.length; i++) {
                if (parseInt(exercise.tags[i].type) === 4) {
                    selectedTagId = exercise.tags[i].id + '';
                    break;
                }
            }

            let selectedValue = null;

            for (let i = 0; i < allSchemes.length; i++) {
                let scheme = { ...allSchemes[i] };
                scheme.matchCount = 0;
                if (scheme.id === exercise.workout_set_exercise_template_id) {
                    if (scheme.tags.length) {
                        let optionTags = [];
                        Object.keys(scheme.tags).forEach(function(key) {
                            let tag = scheme.tags[key];
                            if (selectedTagId === tag.id) {
                                optionTags.push({
                                    ...tag,
                                    match: true
                                });
                            }
                        });
                        scheme.tags = optionTags;
                    }
                    selectedValue = scheme;
                } else if (scheme.tags.length) {
                    let optionTags = [];
                    Object.keys(scheme.tags).forEach(function(key) {
                        let tag = scheme.tags[key];
                        if (selectedTagId === tag.id) {
                            optionTags.push({
                                ...tag,
                                match: true
                            });
                            scheme.matchCount = 1;
                        }
                    });
                    scheme.tags = optionTags;
                    if (scheme.matchCount > 0) {
                        tagResults.push(scheme);
                    }
                }
            }

            tagResults = _.sortBy(tagResults, function(option) {
                return -option.matchCount;
            });

            if (selectedValue) {
                tagResults.unshift({ ...selectedValue });
            }

            return tagResults;
        }
    }

    showSchemeSaver() {
        let exercise = this.props.exercise;
        let schemeRef = this.props.schemeRef;
        if (exercise.param_count && exercise.abr) {
            let found = schemeRef.filter(
                ref => ref.title && ref.title.trim() === exercise.abr.trim()
            );
            return !found.length;
        }
        return false;
    }
    updateScheme(value, prescriptionData = null) {
        let prescription = this.props.schemeRef.filter(
            s => s.id === (value.key || value.id)
        );
        let block = this.props.block;
        let exercise = this.props.exercise;
        let exTpl = _.find(this.props.exerciseRef, {
            id: exercise.exercise_id
        });
        let dispatch = this.props.dispatch;
        if (!prescription.length) {
            prescription = {
                id: 0,
                custom: 1,
                title: 'Custom',
                tags: [],
                param_1_type: exTpl ? exTpl.param_1_type : 0,
                param_2_type: exTpl ? exTpl.param_2_type : 0
            };
        } else {
            prescription = { ...prescription[0] };
            if (!prescription.param_2_type) {
                prescription.param_2_type = exTpl.param_2_type;
                for (var i = 1; i <= prescription.param_count; i++) {
                    prescription[`param_2_data_${i}`] = '';
                }
            }
        }
        console.log(prescription);
        if (prescriptionData && Object.keys(prescriptionData).length) {
            prescription.tags = [prescriptionData];
        }
        DesignerState.updateRepScheme(dispatch, block, exercise, prescription);
    }

    applyLastPerformance(prescription) {
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        let exercise = this.props.exercise;
        DesignerState.updateRepScheme(dispatch, block, exercise, prescription);
        SegmentService.track(EVENTS.ClickCTA.key, {
            sources: 'Web App',
            ctaText: 'Repeat this Performance',
            ctaLocation: 'Last Performance'
        });
    }

    render() {
        Console.render('designer.ExerciseRepTable');
        let { dispatch, session, block, exercise, athleteId } = this.props;
        let trainingEffectClasses = 'training-effect placeholder-custom';
        const disabled = !this.showSchemeSaver();
        const buttonText = disabled ? '✓  Saved' : 'Save Prescription';
        let trainingEffect = (
            <div className={trainingEffectClasses}>
                <div className="scheme-ref">
                    <PrescriptionDrop
                        placeholder="Prescription"
                        disabled={this.props.disabled}
                        categories={this.props.schemeTags}
                        prescriptions={this.props.schemeRef}
                        onSelect={this.updateScheme.bind(this)}
                        exercise={exercise}
                    />
                </div>
                <Button
                    disabled={disabled}
                    className="MegaDrop-rx-button"
                    onClick={() => {
                        const exercise = this.props.exercise;
                        const abr = Utils.calculateAbr(exercise);
                        DesignerState.toggleSchemeModal(exercise, abr, true);
                    }}
                >
                    {buttonText}
                </Button>
            </div>
        );

        const tableStyles = {
            display: exercise && exercise.id ? 'block' : 'none'
        };

        return (
            <div style={tableStyles}>
                {trainingEffect}
                <div>
                    <RepTable
                        workoutId={session.workout_id}
                        exercise={exercise}
                        block={block}
                        dispatch={dispatch}
                    />
                    <LastPerformance
                        date={session.date}
                        athleteId={athleteId}
                        isSubscription={session.program_type === 1}
                        workoutSetExercise={exercise}
                        applyPrescription={this.applyLastPerformance.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

let mapStateToExerciseRepTableProps = function(state, ownProps) {
    return {
        ...ownProps,
        schemeRef: state.library.schemeRef,
        exerciseRef: state.library.exerciseRef,
        schemeTags: state.calendar.uiTree.schemeTags,
        athleteId: state.calendar.infoTree.athleteId
    };
};

export default connect(mapStateToExerciseRepTableProps)(ExerciseRepTable);



// WEBPACK FOOTER //
// ./src/view/designer/components/Exercise/ExerciseRepTable.jsx